{
  "version": 1,
  "asset_id": "331ac675-1c39-41dc-a514-c41d9e135b33",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/331ac675-1c39-41dc-a514-c41d9e135b33/sleeve-dissection-revision-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/331ac675-1c39-41dc-a514-c41d9e135b33/sleeve-dissection-revision-800.jpg",
  "original_filename": "sleeve-dissection-revision-800.jpg",
  "size": 67371,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T12:43:14Z"
}
